import React from "react";
import { withFormik } from "formik";

import { Modal } from "../../../../components/modal";
import { ValidatedForm } from "../../../../components";
import { type PackRequest } from "../types/state";
import { type EnablePackModalProps, type EnablePackModaWithFormProps } from "./types";
import EnablePackForm from "./EnablePackForm";
import { enablePackValidationSchema } from "../../../../utils/validationSchemas/packRequestValidationSchema";
import RequestPackModalActions from "./RequestPackModalActions";
import ModalSizes from "../../../../enums/modalSizes";
import schemasUtils from "utils/validationSchemasUtils";
import "./packRequestModal.scss";
import { useFeatureFlag } from "hooks/useFeatureFlag";
import { FeatureFlags } from "featureFlags";
import AddPackForm from "./AddPackForm";
import { LicenseTypes } from "enums";

export const EnablePackModal: React.FC<EnablePackModaWithFormProps> = (props) => {
  const { values, isValid, resetForm, onCancelPackRequest, onSubmitEnablePack } = props;

  const isPaidPacksEnabled = !!useFeatureFlag(FeatureFlags.PaidPacks);
  const modalTitle = isPaidPacksEnabled ? "Add Pack to Account" : "Purchase Pack";
  const submitButtonText = isPaidPacksEnabled ? "Add to Account" : "Purchase Now";

  const renderModalActions = (closeModal: any) => {
    return (
      <RequestPackModalActions
        onSubmit={() => {
          onSubmitEnablePack(values);
          closeModal();
        }}
        onCancel={() => {
          closePackRequestModal();
          closeModal();
        }}
        isValid={isValid}
        submitText={submitButtonText}
      />
    );
  };

  const closePackRequestModal = () => {
    resetForm();
    onCancelPackRequest?.();
  };

  return (
    <Modal
      className="pack-request-modal"
      title={modalTitle}
      open={props.isOpen}
      renderModalActions={renderModalActions}
      onCancel={closePackRequestModal}
      size={ModalSizes.tiny}
      dataTestId="enable-pack-modal"
    >
      <ValidatedForm formWidthComputer={16} formWidthTablet={16} {...props}>
        {isPaidPacksEnabled ? <AddPackForm {...props} /> : <EnablePackForm {...props} />}
      </ValidatedForm>
    </Modal>
  );
};

/* istanbul ignore next */
const ConnectedComponent = withFormik<EnablePackModalProps, PackRequest>({
  validateOnMount: true,
  validationSchema: (props: EnablePackModalProps) => {
    return enablePackValidationSchema(!!props.unlimitedLicenses);
  },
  isInitialValid: (props: EnablePackModalProps) => {
    return schemasUtils.isValidSync(enablePackValidationSchema(!!props.unlimitedLicenses), props);
  },
  mapPropsToValues: (props: EnablePackModalProps) => {
    return {
      packId: props.packId,
      licenseType: LicenseTypes.CustomDate,
    } as PackRequest;
  },
  handleSubmit: () => {}, // NOSONAR
  enableReinitialize: true,
})(EnablePackModal);

export default ConnectedComponent;
